/**
 * Privacy-first event logger for the public preview funnel.
 * Fire-and-forget — never blocks the UI on the backend response.
 */
import api from '@/lib/api';

const ALLOWED = new Set([
  'preview_view',
  'preview_sticky_shown',
  'preview_sticky_cta',
  'preview_sticky_dismiss',
  'preview_bottom_cta',
  'preview_invite_click',
  'invite_page_view',
  'invite_whatsapp_click',
  'invite_qr_download',
]);

export function trackPreviewEvent(event, opts = {}) {
  if (!ALLOWED.has(event)) return;
  // de-dupe quick repeats of the same event in same tab (single-page navs)
  try {
    const k = `pe:${event}`;
    const last = Number(window.sessionStorage.getItem(k) || 0);
    const now = Date.now();
    if (now - last < 1500) return; // 1.5s debounce
    window.sessionStorage.setItem(k, String(now));
  } catch (_) { /* ignore */ }

  const body = {
    event,
    source: opts.source || (typeof window !== 'undefined' ? window.location.search.replace(/^\?/, '').slice(0, 64) : ''),
    referrer: typeof document !== 'undefined' ? (document.referrer || '').slice(0, 512) : '',
  };
  // Non-blocking. Swallow any error — analytics must never break UX.
  api.post('/analytics/preview-event', body).catch(() => {});
}
